import Vue from 'vue'
import Router from 'vue-router'

const List = resolve => {
	require.ensure([], () => {
		resolve(require('../views/list/list.vue'))
	})
};

const Topic = resolve => {
	require.ensure([], () => {
		resolve(require('../views/topic/topic.vue'));
	});
};

const Login = resolve => {
	require.ensure([], () => {
		resolve(require('../views/login/login.vue'));
	});
};

const Edit = resolve => {
	require.ensure([], () => {
		resolve(require('../views/edit/edit.vue'));
	});
};

Vue.use(Router)

export default new Router({
	routes: [{
		name: "root",
		path: '/',
		redirect: "/list"
	}, {
		name: 'list',
		path: '/list',
		component: List
	}, {
		name: "topic",
		path: '/topic/:id',
		component: Topic
	}, {
		name: "login",
		path: '/login',
		component: Login
	}, {
		name: "edit",
		path: '/edit',
		component: Edit,
		meta: {
			requiresAuth: true
		}
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js